import { TableContainer, TablePagination } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { useAppSelector } from "hooks"
import { useState } from "react"
import type { IDeviceEvent } from "types/deviceTypes"

export function DeviceEventList() {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [searchText] = useState<string>("")

  const deviceEvents = useAppSelector((state) => state.device.deviceEvents)

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const filterDeviceEvents = (
    _value: string,
    deviceEvents: Array<IDeviceEvent>,
  ): Array<IDeviceEvent> => {
    return deviceEvents
  }

  return (
    <TableContainer>
      <div style={{ minHeight: "280px" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Application</TableCell>
              <TableCell>Event</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Date</TableCell>
              <TableCell align="right" padding="checkbox"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterDeviceEvents(searchText, deviceEvents)
              .slice()
              .sort((a, b) => {
                return new Date(b.date).valueOf() - new Date(a.date).valueOf()
              })
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((deviceEvent, _index) => (
                <TableRow key={deviceEvent.id} hover>
                  <TableCell>{deviceEvent.applicationId}</TableCell>
                  <TableCell>{deviceEvent.event}</TableCell>
                  <TableCell>{deviceEvent.message}</TableCell>
                  <TableCell>{new Date(deviceEvent.date).toLocaleString()}</TableCell>
                  <TableCell align="right" onClick={(e) => e.stopPropagation()}></TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25]}
        count={filterDeviceEvents(searchText, deviceEvents).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  )
}
